import { RoleId, RoleSimple, SelectOptionType } from 'types';

export const parseRoleIntoSelectOptionType: (simpleRole: RoleSimple) => SelectOptionType<RoleId> = (
    groupDetails,
) => ({
    label: groupDetails.name,
    value: groupDetails.id,
});
